import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// themes.css first: it declares the palette custom properties App.css consumes.
import './themes.css';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './components/Login';
import Shell from './components/Shell';

function Gate() {
  const { isAuthed } = useAuth();
  return (
    <Routes>
      <Route path="/" element={isAuthed ? <Navigate to="/overview" replace /> : <Login />} />
      <Route path="/*" element={isAuthed ? <Shell /> : <Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="sa-app">
            <Gate />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
